import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { getDataLayer } from '@app/analytics/reducers';
import { IAppState } from '@app/store';

import { PlatformService } from '@app/shared/services/platform/platform.service';

@Injectable({
  providedIn: 'root'
})
export class DataLayerService {
  private scriptPushed = false;

  constructor(private platformService: PlatformService, private store: Store<IAppState>) {}

  // Tag commander's DataLayer
  flush(): void {
    if (!this.platformService.isBrowser) {
      return;
    }
    this.store.pipe(select(getDataLayer)).subscribe(
      dL => {
        window['tc_vars'] = dL || {};

        if (!this.scriptPushed && dL && dL.authAttempted && !this.platformService.isVCScrapper) {
          const scriptElt1 = document.createElement('script');
          scriptElt1.id = 'tc_script__7';
          scriptElt1.type = 'text/javascript';
          scriptElt1.src = '//cdn.tagcommander.com/310/tc_Vestiairecollective_7.js?ts=' + Date.now();
          scriptElt1.async = false;
          scriptElt1.defer = false;
          (
            document.getElementsByTagName('body')[0] || document.getElementsByTagName('script')[0].parentNode
          ).insertBefore(scriptElt1, null);

          const scriptElt2 = document.createElement('script');
          scriptElt2.id = 'tc_script__1';
          scriptElt2.type = 'text/javascript';
          scriptElt2.src = '//cdn.tagcommander.com/310/tc_Vestiairecollective_1.js?ts=' + Date.now();
          scriptElt2.async = false;
          scriptElt2.defer = false;
          (
            document.getElementsByTagName('body')[0] || document.getElementsByTagName('script')[0].parentNode
          ).insertBefore(scriptElt2, null);

          this.scriptPushed = true;
        }
      },
      error => {
        // Silently fails
      }
    );
  }

  // Google Tag Manager's DataLayer
  pushGA(payload: any): void {
    if (!this.platformService.isBrowser) {
      return;
    }

    window['dataLayer'] = window['dataLayer'] || [];

    window['dataLayer'].push(payload);
  }
}
